const LOAD_ADMIN_DASHBOARDS = {
  BEGIN: "LOAD_ADMIN_DASHBOARDS_BEGIN",
  SUCCESS: "LOAD_ADMIN_DASHBOARDS_SUCCESS",
  FAILURE: "LOAD_ADMIN_DASHBOARDS_FAILURE"
};

const LOAD_ADMIN_DASHBOARD = {
  BEGIN: "LOAD_ADMIN_DASHBOARD_BEGIN",
  SUCCESS: "LOAD_ADMIN_DASHBOARD_SUCCESS",
  FAILURE: "LOAD_ADMIN_DASHBOARD_FAILURE"
};

const ADD_NEW_ADMIN_DASHBOARD = {
  BEGIN: "ADD_NEW_ADMIN_DASHBOARD_BEGIN",
  SUCCESS: "ADD_NEW_ADMIN_DASHBOARD_SUCCESS",
  FAILURE: "ADD_NEW_ADMIN_DASHBOARD_FAILURE"
};

const UPDATE_SELECT_PAGE = "UPDATE_SELECT_PAGE";

// const initialState = {};
const initialState = { dashboards: [], currentPage: 1, totalPages: 0 };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ADMIN_DASHBOARDS.SUCCESS:
      return { ...state, ...action.payload };
    case LOAD_ADMIN_DASHBOARD.SUCCESS: {
      const { id } = action.payload;
      state.dashboards = { ...state.dashboards, [id]: action.payload };
      return { ...state };
    }
    case ADD_NEW_ADMIN_DASHBOARD.SUCCESS: {
      const { dashboard } = action.payload;
      state.dashboards = {
        ...state.dashboards,
        [dashboard.id]: { ...dashboard }
      };
      return { ...state };
    }
    case UPDATE_SELECT_PAGE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const loadAdminDashboards = query => {
  return {
    types: [
      LOAD_ADMIN_DASHBOARDS.BEGIN,
      LOAD_ADMIN_DASHBOARDS.SUCCESS,
      LOAD_ADMIN_DASHBOARDS.FAILURE
    ],
    api: api => api.loadAdminDashboards(query)
  };
};

export const loadAdminDashboard = id => {
  return {
    types: [
      LOAD_ADMIN_DASHBOARD.BEGIN,
      LOAD_ADMIN_DASHBOARD.SUCCESS,
      LOAD_ADMIN_DASHBOARD.FAILURE
    ],
    api: api => api.loadAdminDashboard(id)
  };
};

export const addNewAdminDashboard = body => {
  return {
    types: [
      ADD_NEW_ADMIN_DASHBOARD.BEGIN,
      ADD_NEW_ADMIN_DASHBOARD.SUCCESS,
      ADD_NEW_ADMIN_DASHBOARD.FAILURE
    ],
    api: api => api.addNewAdminDashboard(body)
  };
};

/* Getters */
export const searchDashboards = (dashboards, searchValue, type) => {
  dashboards = Object.values(dashboards).filter(d => {
    let searchResult =
      d.name.toLowerCase().indexOf(searchValue) > -1 ||
      (d.campaignName &&
        d.campaignName.toLowerCase().indexOf(searchValue) > -1);
    return searchResult;
  });
  if (!dashboards.length) {
    return {};
  }
  if (type !== "all") {
    dashboards = dashboards.filter(d => d.type === type);
  }

  return dashboards.reduce((acc, dashboard) => {
    acc[dashboard.id] = dashboard;
    return acc;
  }, {});
};

export const updateSelectedPage = newPage => {
  return {
    type: UPDATE_SELECT_PAGE,
    payload: { currentPage: newPage.value }
  };
};
